import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useBotChatsQuery } from '../../hooks/queries';
import { legacyChatTarget, legacyHistoryTarget } from '../../components/bots/chatLinks';

/**
 * An older link to a bot's page (/app/bots/<bot>?project=&chat=) or its chat history
 * (/app/bots/<bot>/chats): notifications, phones and the desktop app still send them. Each
 * lands in Chats (components/bots/chatLinks.js); 'last' and a project without a chat wait for
 * the bot's chats to find the latest one.
 */
const ChatLinkPage = () => {
  const { botId } = useParams();
  const { pathname, search } = useLocation();
  const history = pathname.endsWith('/chats');
  const params = new URLSearchParams(search);
  const link = { botId, project: params.get('project') || null, chat: params.get('chat') || null };
  const latest = !history && botId !== 'queen' && (link.chat === 'last' || (!!link.project && !link.chat));
  const { data, isError } = useBotChatsQuery(latest ? botId : null, null, { retry: false });
  const target = history ? legacyHistoryTarget(botId) : legacyChatTarget(link, isError ? [] : data?.chats);
  if (!target) {
    return <div className="h-full py-16 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-muted-foreground" /></div>;
  }
  return <Navigate to={target} replace />;
};

export default ChatLinkPage;
